import { useSyncExternalStore } from 'react';

// Cross-component readiness signal: true once OpenObserveProvider has finished
// openobserveRum.init() + setUser() with complete user data. Other places that
// call openobserveRum.addAction/addError directly (e.g. deeplink tracking, which
// isn't gated by OpenObserveProvider's own effect) can check/wait on this to
// avoid sending events before usr context is set.

type Listener = () => void;

let isReady = false;
const listeners = new Set<Listener>();

export const markOpenObserveReady = () => {
	if (isReady) {
		return;
	}
	isReady = true;
	listeners.forEach(listener => listener());
};

const subscribe = (listener: Listener) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};

const getSnapshot = () => isReady;
const getServerSnapshot = () => false;

export const useIsOpenObserveReady = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

// Plain (non-hook) synchronous check for imperative code that isn't part of a
// component's render, e.g. checks made mid-way through an async callback.
export const getIsOpenObserveReady = () => isReady;
